import React from 'react'
import { SupplierDetailFormAdminStyle } from './styled'
import { Button, Input, Section } from '../../components'
import { ROUTE_PATH, STRING, EMAIL_REGEX, trimmedString } from '../../helpers'
import { Form, Formik } from 'formik'
import { supplierManagementController } from '../../apiService'
import { toast } from 'react-toastify'
import { findId } from '../../helpers/functions/findIdUrl'
import Header from './components/Header'
import * as Yup from 'yup'

import ModalConfirm from './components/ModalConfirm'
export default class SuppilerEditWaitActiveContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isEditPageState: true,
      isActive: true,
      isRequested: true,
      modals: [
        // { name: 'history', isOpen: false },
        { name: 'delete', isOpen: false },
        { name: 'rejectSupplier', isOpen: false },
      ],
      isLoading: false,
      detailFrom: {
        id: null,
        taxId: '',
        companyName: '',
        regAddress: '',
        regCountry: '',
        contactAddress: '',
        contactCountry: '',
        fullName: '',
        email: '',
        phone: '',
        approveStatus: '',
        fax: '',
        website: '',
        active: true,
        updateBy: '',
        updateDate: '',
      },
    }
  }

  componentDidMount() {
    this.fetchSuppierByID()
  }

  initDetailForm = (
    values = {
      id: null,
      tax_id: '',
      company_name: '',
      regis_address: '',
      regis_country: '',
      contact_address: '',
      contact_country: '',
      supplier_full_name: '',
      supplier_email: '',
      supplier_phone: '',
      approve_status: null,
      status: null,
      update_by: '',
      update_date: '',
    }
  ) => {
    this.setState({
      detailFrom: {
        id: values.id,
        taxId: values.tax_id,
        companyName: values.company_name,
        regAddress: values.regis_address,
        regCountry: values.regis_country,
        contactAddress: values.contact_address,
        contactCountry: values.contact_country,
        fullName: values.supplier_full_name,
        email: values.supplier_email,
        phone: values.supplier_phone,
        approveStatus: values.approve_status,
        fax: '',
        website: '',
        active: values.status === 2 ? true : false,
        updateBy: values.update_by,
        updateDate: values.update_date,
      },
    })
  }

  fetchSuppierByID = async () => {
    try {
      const id = findId(window.location.pathname)
      const res = await supplierManagementController().getByID(id)
      if (res) {
        this.initDetailForm(res)
      }
    } catch (error) {
      throw new Error('fetchSuppierByID fail', error)
    }
  }

  goListSuppilerManagementPage = () => {
    setTimeout(
      this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK),
      3000
    )
  }

  cancelInvite = async (values, formikActions) => {
    if (values) {
      try {
        const params = {
          supplier_id: parseInt(values.id),
        }
        const res = await supplierManagementController().cancelInvite(params)
        if (res) {
          this.setState({ isLoading: false })
          if (res.status === 'UpdateSuccess') {
            toast.success('Cancel Invite was success')
            this.goListSuppilerManagementPage()
            setTimeout(formikActions.resetForm(), 3000)
          } else {
            toast.error(res.message)
          }
        }
      } catch (error) {
        throw new Error('cancelInvite fail', error)
      }
    }
  }

  onClickResendMail = async (formikActions = '') => {
    if (!formikActions.values.email) {
      return formikActions.setErrors({ email: STRING.INVALID })
    }
    const emailFormatValid = !RegExp(EMAIL_REGEX).test(
      formikActions.values.email
    )
    if (emailFormatValid) {
      return formikActions.setErrors({ email: STRING.EMAIL_INVALID })
    }
    try {
      const params = {
        supplier_id: parseInt(formikActions.values.id),
        admin_supplier_email: formikActions.values.email,
      }
      const res = await supplierManagementController().resendEmail(params)
      if (res.status === 'EmailDuplicate') {
        return formikActions.setErrors({
          email: 'Email duplicate please change email',
        })
      }
    } catch (error) {
      throw new Error('error', error)
    }
    console.log('ResendMail', formikActions)
  }

  onConFirm = async (values = {}, formikActions = () => {}) => {
    try {
      this.setState({ isLoading: true })
      if (values && formikActions) {
        this.cancelInvite(values, formikActions)
      }
    } catch (error) {
      throw new Error(error)
    }
  }

  onClickCancel = () => {
    this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK)
  }

  handleInput = (formikActions = () => {}, e) => {
    const { name, value } = e.target
    formikActions.setFieldValue(name, value)
    formikActions.setErrors({ ...formikActions.errors, [name]: '' })
  }

  handleInputTaxId = (formikActions = () => {}, e) => {
    const { name, value } = e.target
    if (value !== formikActions.values.taxId) {
      formikActions.setFieldValue(name, value)
      formikActions.setErrors({ ...formikActions.errors, taxId: '' })
      this.setState({ disableButton: true, verify: false })
    }
  }

  toggleModal = evt => {
    this.setState(
      prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === evt ? !modal.isOpen : false,
        })),
      }),
      () => {
        console.log(this.state.modals)
      }
    )
  }

  validateSchema = () => {
    const schema = Yup.object().shape({
      taxId: Yup.string().required(STRING.INVALID),
      fullName: Yup.string()
        .transform(fullName => trimmedString(fullName))
        .nullable()
        .required(STRING.INVALID),
      email: Yup.string()
        .transform(email => trimmedString(email))
        .nullable()
        .required(STRING.INVALID)
        .email(STRING.EMAIL_INVALID),
      phone: Yup.string()
        .transform(phoneValue => trimmedString(phoneValue))
        .nullable()

        .required(STRING.INVALID),
    })
    return schema
  }

  render() {
    const { isEditPageState, modals } = this.state
    const { accountStatus } = this.props.location.state
    const statusApprove = accountStatus === 1
    return (
      <React.Fragment>
        <SupplierDetailFormAdminStyle>
          <Header {...this.props} />
          <Formik
            validationSchema={this.validateSchema}
            enableReinitialize={true}
            initialValues={this.state.detailFrom}
            validateOnBlur={true}
            validateOnChange={false}
            validateOnMount={false}
            onSubmit={(values, actions) => {
              this.onConFirm(values, actions)
            }}
          >
            {formikProp => {
              return (
                <React.Fragment>
                  <Section className="main-content form">
                    <Section className="content-body">
                      <Section className="form-wrapper">
                        <Section className="form-group-title">
                          {STRING.EDIT_SUPPLIER}
                        </Section>
                        <Form onSubmit={formikProp.handleSubmit}>
                          <Section
                            className={`form-group ${
                              formikProp.errors.taxId && 'is-error'
                            }`}
                          >
                            <label>Tax ID</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  name="taxId"
                                  value={formikProp.values.taxId}
                                  onChange={event =>
                                    this.handleInputTaxId(formikProp, event)
                                  }
                                  onBlur={formikProp.handleBlur('taxId')}
                                  disabled={true}
                                />
                                {statusApprove && (
                                  <Button
                                    disabled={this.state.verify ? true : false}
                                    className="theme-blue verify"
                                    onClick={() =>
                                      this.onClickVerify(formikProp)
                                    }
                                  >
                                    Verify
                                  </Button>
                                )}
                              </Section>

                              <Section className="message">
                                {formikProp.errors.taxId}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.companyName && 'is-error'
                            }`}
                          >
                            <label>Company Name</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  disabled={true}
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  onBlur={formikProp.handleBlur('companyName')}
                                  value={formikProp.values.companyName}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.values.companyName}
                              </Section>
                            </Section>
                          </Section>

                          <Section className="form-group-header">
                            Contact Person
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.fullName && 'is-error'
                            }`}
                          >
                            <label>Full name</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  name="fullName"
                                  onBlur={formikProp.handleBlur('fullName')}
                                  value={formikProp.values.fullName}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.errors.fullName}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.email && 'is-error'
                            }`}
                          >
                            <label>Email</label>

                            <Section className="form-group-control with-button">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  name="email"
                                  onBlur={formikProp.handleBlur('email')}
                                  value={formikProp.values.email}
                                />

                                {isEditPageState && (
                                  <Button
                                    className="theme-blue resend-activation-email"
                                    onClick={() =>
                                      this.onClickResendMail(formikProp)
                                    }
                                  >
                                    Resend Activation Email
                                  </Button>
                                )}
                              </Section>

                              <Section className="message">
                                {formikProp.errors.email}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.phone && 'is-error'
                            }`}
                          >
                            <label>Phone</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  name="phone"
                                  onBlur={formikProp.handleBlur('phone')}
                                  value={formikProp.values.phone}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.errors.phone}
                              </Section>
                            </Section>
                          </Section>
                        </Form>
                      </Section>

                      <Section className="form-actions">
                        <Button
                          className="theme-border-gray"
                          onClick={() => this.onClickCancel()}
                        >
                          Cancel
                        </Button>

                        <Button
                          className="theme-blue"
                          onClick={() => {
                            this.toggleModal('delete')
                          }}
                        >
                          Cancel Invite
                        </Button>
                      </Section>
                    </Section>
                  </Section>
                  <ModalConfirm
                    companyName={this.state.detailFrom.companyName}
                    isOpen={
                      modals
                        .filter(modal => {
                          return modal.name === 'delete'
                        })
                        .map(obj => obj.isOpen)[0]
                    }
                    toggleModal={() => this.toggleModal('delete')}
                    onClickConfirm={formikProp.handleSubmit}
                  />
                </React.Fragment>
              )
            }}
          </Formik>
        </SupplierDetailFormAdminStyle>
      </React.Fragment>
    )
  }
}
